import type { VNode } from "vue";
import { defineComponent, h } from "vue";

export const DetailCellRendererWrapper = defineComponent({
  name: "DetailCellRendererWrapper",
  render(): VNode {
    const params = (this as any).params;
    return h(
      "div",
      params.renderFn({
        item: params.data,
      })
    );
  },
});
